module.exports = __webpack_public_path__ + "static/media/remoteEye-Logo-Detailed-Grayscale.9c8d67b4.png";